export default __webpack_public_path__ + "static/media/phone-android.6bf30863.svg";